var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnapprovedQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.9141,
    cy: 32.1172,
    r: 32,
    fill: "#E6F4FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3593 32.1181C49.3593 41.1946 41.9965 48.5525 32.914 48.5525C23.8315 48.5525 16.4688 41.1946 16.4688 32.1181C16.4688 23.0416 23.8315 15.6836 32.914 15.6836C41.9965 15.6836 49.3593 23.0416 49.3593 32.1181ZM36.858 25.6283L32.9127 29.5736L28.9685 25.6295C28.2662 24.9271 27.1275 24.9271 26.4252 25.6295C25.7229 26.3318 25.7229 27.4705 26.4252 28.1728L30.3693 32.1169L26.4252 36.0611C25.7229 36.7634 25.7229 37.9021 26.4252 38.6044C27.1275 39.3067 28.2662 39.3067 28.9685 38.6044L32.9127 34.6603L36.858 38.6056C37.5603 39.3079 38.699 39.3079 39.4013 38.6056C40.1036 37.9033 40.1036 36.7646 39.4013 36.0623L35.456 32.1169L39.4013 28.1716C40.1036 27.4693 40.1036 26.3306 39.4013 25.6283C38.699 24.926 37.5603 24.926 36.858 25.6283Z",
    fill: "#2995DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnapprovedQuotes);
export default __webpack_public_path__ + "static/media/unapprovedQuotes.cafec18101762d18aad0ed3f079cb0cb.svg";
export { ForwardRef as ReactComponent };